export const QUOTATION_DATE_FILTER_FIELD = "quotationDateFilterField";
